/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect} from 'react';
import {useNotificationStore} from "../../stores/NotificationStore.js";
import {Notification} from "../../Notification.jsx";
import DateTime from "toolbox/dateTime";
import DisplayIcon from "../Icons/DisplayIcon.jsx";

function NotificationLog() {
    const notifications = useNotificationStore((state) => state.notifications);
    const markRead = useNotificationStore((state) => state.markRead);


    useEffect(() => {
        const offlineHandler = () => {
            Notification.createError(
                "The connection to the internet was interrupted",
                "Please check your devices internet connection "
            );
        };
        window.addEventListener("offline", offlineHandler, false);

        return () => {
            window.removeEventListener("offline", offlineHandler);
        };
    }, []);

    const sortedNotifications = [...notifications].sort((a, b) => b.timestamp - a.timestamp);

    const renderEntry = (item) => {
        const typeStyles = {
            ERROR: {
                iconName: "PiXCircle",
                iconColor: "text-red-500",
                iconBg: "bg-red-50",
            },
            WARNING: {
                iconName: "PiWarningCircle",
                iconColor: "text-amber-500",
                iconBg: "bg-amber-50",
            },
            INFO: {
                iconName: "PiInfo",
                iconColor: "text-blue-500",
                iconBg: "bg-blue-50",
            },
        };

        const style = typeStyles[item.type] ?? typeStyles.INFO;

        return (
            <div key={item.id} onClick={() => !item.isRead && markRead(item.id)}>
                <div
                    className={`flex items-start gap-3 px-3 py-3 rounded-lg cursor-pointer`}
                >
                    <div className={`shrink-0 flex items-center justify-center size-6 rounded-full ${style.iconBg}`}>
                        <DisplayIcon iconName={style.iconName} className={`size-3 ${style.iconColor}`}/>
                    </div>

                    <div className="w-0 flex-1 mt-0.5">
                        <div className="text-sm font-semibold text-gray-900">
                            {item.data.title}
                        </div>
                        <div className="mt-0.5 text-sm text-gray-600 leading-snug">
                            {item.data.text}
                            {item.data.linkShowMe && (
                                <span className="ml-1 text-blue-500 hover:text-blue-600 hover:underline font-medium">
                            {item.data.linkShowMe}
                        </span>
                            )}
                        </div>
                        <div className="mt-1.5 text-xs text-gray-400">
                            {DateTime.formatDistanceToNow(DateTime.fromUnixTime(item.timestamp))}
                        </div>
                    </div>

                    <div className="shrink-0 mt-1.5 w-2">
                        {!item.isRead && (
                            <div className="bg-blue-500 rounded-full h-2 w-2"/>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className={" space-y-3"}>
                {sortedNotifications.map(renderEntry)}
            </div>
        </>
    );
}

export default NotificationLog;